module.exports = __webpack_public_path__ + "eb020db46654546011db3d400117cca8.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/broschuere20_image.jpg
// module id = 607
// module chunks = 0